<template>
  <v-card v-if="countAllstd > 0" outlined rounded="lg" :loading="loading" class="pa-3 h-100">
    <div class="section-card-title">
      <v-icon color="#B3151B" class="mr-2">mdi-teach</v-icon>
      ครูผู้สอนแยกตามสาขาวิชา
      <span class="section-card-count">{{ numberWithCommas(countAllstd) }} คน</span>
    </div>

    <apexchart type="bar" height="380" :options="chartOptions" :series="series"></apexchart>
  </v-card>
</template>

<script>
// ข้อมูลครูผู้สอนแยกตามสาขาวิชา — มาจากระบบ HRvec_openapi กลาง (เหตุผลเดียวกับ manPowerHrvec.vue)
export default {
  name: "DashboardOvecMasterPersonnelEtcId",

  data() {
    return {
      loading: true,
      series: [],
      chartOptions: { chart: { type: "bar" } },
      countAllstd: 0,
      rawData: []
    };
  },

  async mounted() {
    await this.personnel_etc_idQuery();
  },

  methods: {
    numberWithCommas(x) {
      x = String(x);
      const pattern = /(-?\d+)(\d{3})/;
      while (pattern.test(x)) x = x.replace(pattern, "$1,$2");
      return x;
    },

    async personnel_etc_idQuery() {
      try {
        this.loading = true;
        let result = await this.$http.post("personnel_etc_id.php", { college_id: this.college_ID });
        const data = Array.isArray(result.data) ? result.data : [];
        this.rawData = data;

        const labelText = [];
        const valuesst = [];
        let countall = 0;
        data.forEach(value => {
          countall += parseInt(value.countB) || 0;
          const classlevel = String(value.id_course_branch).slice(0, 1) === "2" ? "ปวช." : "ปวส.";
          labelText.push(value.branch_name + " " + classlevel + " : " + value.countB);
          valuesst.push(Number(value.countB));
        });
        this.countAllstd = countall;
        this.series = [{ data: valuesst }];
        this.chartOptions = {
          chart: { type: "bar", height: 380 },
          plotOptions: {
            bar: { borderRadius: 10, barHeight: "100%", distributed: true, dataLabels: { position: "top" } }
          },
          colors: ["#B3151B", "#1B365D", "#A86400", "#424242", "#8E1014", "#9E9E9E", "#212121", "#E57373"],
          dataLabels: {
            enabled: true,
            formatter: val => val,
            offsetY: -20,
            style: { fontSize: "12px", colors: ["#B3151B"] }
          },
          stroke: { width: 1, colors: ["#fff"] },
          xaxis: { categories: labelText },
          yaxis: { axisBorder: { show: false }, axisTicks: { show: false }, labels: { show: false } },
          tooltip: { theme: "dark", x: { show: false }, y: { title: { formatter: () => "" } } }
        };

        this.$emit("loaded", data);
      } catch (error) {
        this.$emit("loaded", null);
      } finally {
        this.loading = false;
      }
    }
  },

  computed: {
    college_ID() {
      return this.$route.query.college_ID;
    }
  }
};
</script>

<style scoped>
.h-100 {
  height: 100%;
}
.section-card-title {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  font-weight: 700;
  color: #1b365d;
  font-size: 1rem;
  margin-bottom: 8px;
}
.section-card-count {
  margin-left: auto;
  font-weight: 700;
  color: #b3151b;
}
</style>
